import { ChevronIcon } from 'assets';
import React, { useState } from 'react'

const SkillCard = ({ title, score, level, sections }) => {
  const getBadgeColor = (score) => {
    if (score >= 90) return 'bg-[#18B368]';
    if (score >= 70) return 'bg-[#1570EF]';
    if (score >= 50) return 'bg-[#EDA12F]';
    return 'bg-[#E74444]';
  };

  const capitalizeFirstLetter = (text) => {
    if (!text) return text;
    return text.charAt(0).toUpperCase() + text.slice(1);
  };

  return (
    <div className="bg-[#F5FAFF] border border-[#D1E9FF] rounded-lg p-4">
      <div className="flex items-center">
        <h3 className="text-[#1d2939] font-medium m-0">{title}</h3>
        <span className={`${getBadgeColor(score)} text-white px-2 py-1 rounded-full text-xs font-bold ml-2`}>
          {score}%
        </span>
      </div>
      <p className="text-[#475467] text-[13px] font-medium mt-1 mb-2">{level}</p>

      {sections.map((section, idx) => {
        if (section.title === 'Description') {
          return (
            <div key={idx} className="mt-2">
              <p className="text-[#475467] text-sm mt-1 pb-3 border-b">{section.items[0]}</p>
            </div>
          );
        }

        // Inline sections render as "Heading: body" — the copy is a flowing
        // paragraph that grammatically continues the heading, not a bullet list.
        if (section.inline) {
          const body = capitalizeFirstLetter(section.items.join(' '));

          return (
            <div key={idx} className="mt-2">
              <p className="text-[#475467] text-sm">
                <span className="text-[#1d2939] font-medium">{section.title}: </span>
                {body}
              </p>
            </div>
          );
        }

        return (
          <div key={idx} className="mt-2">
            <div className="text-[#1d2939] font-medium text-sm">{section.title}</div>
            <ul className="list-disc pl-5 text-[#475467] text-sm">
              {section.items.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
};

const CollapsibleSection = ({ title, skills }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-[#e0e6ed] rounded-lg overflow-hidden bg-[#F9FAFB] mt-12">
      <div
        className={`flex items-center justify-between m-4 cursor-pointer border-[#EAECF0] ${isOpen && 'border-b pb-4'}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <h2 className="text-[#344054] text-xl font-medium m-0">{title}</h2>
        <ChevronIcon className={`${isOpen ? 'rotate-180' : ''}`} />
      </div>

      <div className={`transition-max-height duration-300 ease-in-out ${isOpen ? '' : 'max-h-0 overflow-hidden'}`}>
        <div className="p-4 grid md:grid-cols-2 gap-4">
          {skills.map((skill, index) => (
            <SkillCard
              key={index}
              title={skill.title}
              score={skill.score}
              level={skill.level}
              sections={skill.sections} // array of { title: string, items: string[] }
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export { CollapsibleSection }
